import { FiltersV2Data } from "PFApp/components/filters_v2/stores/filters_v2_store/filters_v2_store.types";
import { areFilterValuesEmpty } from "PFCore/helpers/filters";
import { FilterV2WithValueOnly } from "PFTypes/filters_v2";

export const hasAnyFilterToSendInApiCall = (filters?: FiltersV2Data<FilterV2WithValueOnly>) =>
  filters &&
  (!areFilterValuesEmpty(filters.mainFilters) ||
    (filters.areChildrenOn && !areFilterValuesEmpty(filters.childrenFilters)));
